<template id="app">
  <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
    <div>
      <v-alert :type="alert_type" :model-value="alert" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
    </div>
    <!-- Header -->
    <header-component :headerTitle="headerText" />
    <v-snackbar
      v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>{{ snackbar.text }}</div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <!-- seacrh, action button and filter -->
    <v-card class="v-card-100 mt-0">
      <v-card-title style="padding:28px;padding-bottom: 0px;" class="action-style">
        <!-- Search fields -->
        <v-row class="ma-1">
          <v-text-field prepend-inner-icon="mdi-magnify" v-model="search_tag" label="Search By Buyer Name"
            style="max-width: 270px;max-height:52px" variant="outlined" color="primary" v-on:keyup.enter="loadData()"></v-text-field>
          <v-spacer></v-spacer>
          <v-actions>
           <v-menu offset-y>
               <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none mr-2 px-5" size="x-large">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in actionList" :key="index" :disabled="isActionDisabled(item)">
                    <v-list-item-title style="cursor: pointer;" @click="updateAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>            
          </v-actions>
          <!-- Filter -->
            <v-expansion-panels class="custom-control_outlined" ref="filterPopupRef" readonly
              style="max-width: 110px; margin-bottom: 28px; min-height: 52px;">
              <v-expansion-panel outlined @click="filterListOfButtons">
                <v-expansion-panel-title>Filter
                </v-expansion-panel-title>
              </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
      </v-card-title></v-card>
    <v-layout column>
      <v-data-table 
           hover
          density="compact"
          :search="search"
          v-model="selected"
          show-select
          disable-pagination
          :hide-default-footer="true"
          :headers="headers"
          :items="table_data"
          :loading="loading"
          :items-per-page="pageSize"
          fixed-header
          height="100%"
          loading-text="Loading Data... Please wait" 
          class="elevation-1"
          return-object
          >
        <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers">
              <span v-if="header.key == 'buyer_code'">
                <a href="#" @click.prevent="navigateToBuyerDetails(item)" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.buyer_code }}</a>
              </span> 
              <span v-else-if="header.key !== 'imags' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else>-</span>
            </template>
        <!-- <template v-for="(header, index) in headers" :key="index" v-slot:[`item.${header.value}`]="{ item }">
          <span v-if="item[header.value] !== null && item[header.value] !== ''">
            {{ item[header.value] }}
          </span>
          <span v-else>
            <span>-</span>
          </span>
        </template> -->
        <!-- <template #[`item.buyer_code`]="{ item }">
          <a @click="navigateToBuyerDetails(item)" style="color: #1976d2; cursor: pointer;">
            <u>{{ item.buyer_code }}</u>
          </a>
        </template> -->
        <template #bottom></template>
      </v-data-table>
    </v-layout>
    <!-- pagination display -->
           <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-2"
                />
    <!-- filter data popup -->
    <v-row justify="center">
      <v-dialog content-class="filter-dispatch" v-model="filteWithSubPopup" persistent max-width="1224px">
        <v-card class="filter_ui">
          <v-card-actions>
            <v-col>
              <v-combobox prepend-inner-icon="mdi-magnify" clearable v-model="city_filt" multiple :items="city_filt_items"
                label="City" variant="outlined"></v-combobox>
            </v-col>
            <v-col>
              <v-combobox prepend-inner-icon="mdi-magnify" clearable v-model="state_filt" multiple
                :items="state_filt_items" label="State" variant="outlined"></v-combobox>
            </v-col>
            <v-col>
              <v-combobox prepend-inner-icon="mdi-magnify" clearable v-model="category_prefe_filt" multiple
              :items="category_prefe_filt_items" label="Category Preference" variant="outlined"></v-combobox>
            </v-col>
            <v-col>
              <v-combobox prepend-inner-icon="mdi-magnify" clearable v-model="status_filt" multiple
                :items="status_filt_items" label="Wasted Certified" variant="outlined"></v-combobox>
            </v-col>
            <v-col>
              <v-text-field
                  v-model="organization_filter"
                  label="Organisation Name*"
                  variant="outlined"
                  type="text"
                  oninput="this.value = this.value.replace(/^[ ]+/g, '').replace(/\s+/g, ' ')"
                ></v-text-field>
                </v-col>
          </v-card-actions>
          <v-card-actions class="margin-10">
            <v-spacer></v-spacer>
            <v-btn variant="outlined" size="small" text color="primary" class="text-none" @click="filteWithSubPopup = false">Cancel</v-btn>
            <v-btn variant="flat" size="small" color="primary" class="text-none" @click="loadData">Apply Filter(s)</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--delete  -->
    <v-row justify="center">
      <v-dialog v-model="deleteDialog" persistent max-width="424px">
        <v-card class="v-card-100">
          <v-card-title class="d-flex">
            <v-spacer></v-spacer>
            <v-btn variant="solo" icon @click="deleteDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-container>
            <v-row class="p-3 text-center">
              <span> {{ warn_tittle }} </span><br>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content: center;">
            <v-btn size="small" variant="outlined" class="text-none" color="primary" @click="deleteDialog = false">Cancel</v-btn>
            <v-btn size="small" variant="flat" class="text-none" color="primary" @click="deletelotconfirm">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- Download popup -->
    <v-row justify="center">
      <v-dialog v-model="downloadDialog" persistent max-width="364px">
        <v-card class="v-card-100">
          <v-card class="v-card-100 mt-0 custom-shadow">
            <v-card-title class="pa-0">
              <v-row class="ma-2">
              <span class="font-weight-bold">Download</span>
              <v-spacer></v-spacer>
                <v-icon @click="downloadDialog = false">mdi-close</v-icon>
            </v-row>
            </v-card-title>
            </v-card>
            <v-card-text class="download-email mt-2">
              <v-row>
                <v-col cols="12" sm="4" md="12">
                  <v-text-field label="Email Id" :rules="emailRules" @input="validateEmail" variant="outlined"  v-model="email_id" type="text"></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn variant="outlined" class="text-none" size="large" color="primary" @click="downloadDialog = false">Cancel</v-btn>
            <v-btn variant="flat" class="text-none" size="large" color="primary" @click="downloadFile('submit')" :disabled="!isEmailValid || number > 0">Submit</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-card>
</template>
<script>
import HeaderComponent from "./../../../commoncomponents/HeaderComponent";
import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
export default {
  data() {
    return {
      headerText: "Manage Buyers",
      alert: false,
      alert_type: 'info',
      alert_message: '',
      search_tag: '',
      selected: [],
      table_data: [],
      headers: [],
      page: 1,
      totalPages: 1,
      totalCount: '',
      pageSize: defaultPageSize,
      pageSizes: defaultPageSizes,
      filteWithSubPopup: false,
      city_filt: [],
      city_filt_items: [],
      state_filt: null,
      state_filt_items: [],
      category_prefe_filt: null,
      category_prefe_filt_items: [],
      status_filt: null,
      status_filt_items: [],
      download_message: '',
      headerTextSub: '',
      snackbar: false,
      deleteDialog: false,
      actionList: ["Add Buyer","Download","Upload","Delete","Edit","Block","Unblock"],
      warn_tittle: '',
      request_condition: '',
      snackbarColor: '',
      organization_filter:'',
      downloadDialog:false,
      email_id:'',
      email_format_rule: [
          v => (/^[\w,.]+([\.-]?[\w,.]+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email_id)) || "Please enter valid Email"
        ],
      isEmailValid:true,
      emailError:'',
      snackbar: {
          color: null,
          icon: null,
          mode: null,
          position: "top",
          text: null,
          timeout: 7500,
          title: null,
          visible: false
        }
        
    }
  },
  components: {
    HeaderComponent
  },
  computed: {
      emailRules() {
        return [
          v => this.emailError || true
        ];
      }
  },
  created() {
    this.download_message = this.$store.state.lotIds;
    this.headerTextSub = this.$store.state.inventoryId;
    this.loadData()
    if (this.headerTextSub === 'success') {
      this.snackbar = true
      this.snackbarColor = 'success'
    }
  },
  methods: {
    showAlert(alert_type, alert_message) {
      this.alert = true;
      this.alert_type = alert_type;
      this.alert_message = alert_message;
      this.scrollToTop();
      this.alertTimeOut();
    },
    alertTimeOut() {
      setTimeout(() => {
        this.alert = false;
      }, 3000);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1
      this.fetchIndexData();

    },
    handlePageChange(value) {
      this.page = value;
      this.fetchIndexData();
    },
    loadData() {
      this.loading = false;
      this.selected = []
      this.table_data = []
      this.page = 1
      this.totalPages = 1
      this.headers = [
        { title: "Client Vendor Code", key: "buyer_code" },
        { title: "Name", key: "name" },
        { title: "Organisation name", key: "organization_name" },
        { title: "City", key: "city" },
        { title: "State", key: "state" },
        { title: "Category Preference Status", key: "category_preference_array" },
        { title: "Status", key: "buyer_status" },
      ];
      this.fetchIndexData();
    },
    fetchIndexData(){
      this.loading = true;
      const convertToEmptyString = (value) => {
        if (Array.isArray(value)) {
          return value.map(item => item === "N/A" ? "" : item);
        }
        return value === "N/A" ? "" : value;
      };

      const requestBody = {
        search_text: this.search_tag,
        page: this.page,
        per_page: this.pageSize,
        filter: {
          city: convertToEmptyString(this.city_filt),
          state: convertToEmptyString(this.state_filt),
          status: convertToEmptyString(this.status_filt),
          category: convertToEmptyString(this.category_prefe_filt),
          organization_name:convertToEmptyString(this.organization_filter)
        }
      };
      this.$httpSecured
        .post(`/api/v1/warehouse/remarketing_buyers`, requestBody)
        .then(response => {
            if (response.data) {
              this.table_data = response.data.remarketing_buyers.map(buyer => ({
            ...buyer,
            category_preference_array: Array.isArray(buyer.category_preference_array)
              ? buyer.category_preference_array.join(', ')
              : buyer.category_preference_array,
            geographical_preference_array: Array.isArray(buyer.geographical_preference_array)
              ? buyer.geographical_preference_array.join(', ')
              : buyer.geographical_preference_array
          }));
            this.filteWithSubPopup = false;
            this.totalPages = response.data.meta.total_pages;
            this.totalCount = response.data.meta.total_count
            this.loading = false;
            this.city_filt = null;
            this.state_filt =null;
            this.category_prefe_filt = null;
            this.organization_filter = null;
            this.status_filt = null;
            this.fetchFilterData();
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
        });
    },
    filterListOfButtons() {
      this.city_filt = null;
      this.state_filt = null;
      this.category_prefe_filt = null;
      this.organization_filter = null;
      this.status_filt = null;
      this.filteWithSubPopup = true;
      document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
    },
    fetchFilterData() {
      this.$httpSecured
        .get(`/api/v1/warehouse/remarketing_buyers/get_filter_values`)
        .then(response => {
          if (response.data) {
            this.city_filt_items = response.data.city_list.map(city => city === "" ? "N/A" : city);
            this.state_filt_items = response.data.state_list.map(state => state === "" ? "N/A" : state);
            this.category_prefe_filt_items = response.data.category_list.map(category => category === "" ? "N/A" : category);
            this.status_filt_items = ["Active", "Blocked", "New"]
          } else {
            this.showAlert("error", "No Data Found");
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
        });
    },
    navigateToBuyerDetails(value) {
      this.$store.commit("setLotIds", {
        lotIds: value.id,
        action: '',
        inventoryId: value.buyer_code
      });
      this.$router.push({ name: "DetailsOfBuyer" });
    },
    navigateToAddBuyers(condition) {
      if (condition === 'add') {
        this.$store.commit("setLotIds", {
          lotIds: '',
          action: condition,
          inventoryId: this.headerText
        });
      } else if (condition === 'edit') {
        this.$store.commit("setLotIds", {
          lotIds: this.selected.map(loc_id => loc_id.id),
          action: condition,
          inventoryId: ''
        });
      }

      this.$router.push({ name: "CreateNewBuyer" });
    },
    afterClickOK() {
      this.snackbar = false
      this.$store.commit("setLotIds", {});
      this.loadData();
      this.snackbarColor = '';
    },
    deletRequest(message) {
      this.request_condition = message
      if (message === 'delete') {
        this.warn_tittle = 'Are you sure you want to delete?'
      } else if (message === 'block') {
        this.warn_tittle = 'Are you sure you want to Block?'
      } else {
        this.warn_tittle = 'Are you sure you want to Unblock?'
      }
      this.deleteDialog = true
    },
    deletelotconfirm() {
      let ids = this.b2b_liq_id = this.selected.map(item => item.id);
      if (this.request_condition === 'delete') {
        this.$httpSecured
          .post("/api/v1/warehouse/remarketing_buyers/delete_buyers",
            {
              "ids": ids
            }
          )
          .then(response => {
            if (response.data) {
              this.ip_selected = [];
              this.deleteDialog = false;
              this.snackbar = true
              this.download_message = response.data.message
              this.snackbarColor = 'success'
              this.loadData();
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
          });
      } else if (this.request_condition === 'block') {
        this.$httpSecured
          .post("/api/v1/warehouse/remarketing_buyers/block_unblock_remarketing_buyer",
            {
              "ids": ids,
              "buyer_status": "inactive"
            }
          )
          .then(response => {
            if (response.data) {
              this.ip_selected = [];
              this.deleteDialog = false;
              this.snackbar = true
              this.download_message = response.data.message
              this.snackbarColor = 'success'
              this.loadData();
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
          });
      } else {
        this.$httpSecured
          .post("/api/v1/warehouse/remarketing_buyers/block_unblock_remarketing_buyer",
            {
              "ids": ids,
              "buyer_status": "active"
            }
          )
          .then(response => {
            if (response.data) {
              this.ip_selected = [];
              this.deleteDialog = false;
              this.snackbar = true
              this.download_message = response.data.message
              this.snackbarColor = 'success'
              this.loadData();
            } else {
              this.showAlert("error", "No Data Found");
            }
          }).catch(error => {
            this.showAlert("error", error.response.data.error);
          });
      }
    },
    validateEmail() {
        const emails = this.email_id.split(',').map(email => email.trim());
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emails.length === 1 && !emailPattern.test(emails[0])) {
          this.emailError = 'Please enter a valid email';
          this.isEmailValid = false
          return;
        }else{
          this.isEmailValid = true
        }

        for (const email of emails) {
          if (!emailPattern.test(email)) {
            this.emailError = 'Please enter valid email ids separated by commas';
            this.isEmailValid = false
            return;
          }else{
            this.isEmailValid = true
          }
        }     

        this.emailError = null;
      },
    openPopup(){
        this.downloadDialog = true;
        this.email_id = this.$store.state.currentUser.email;
        this.validateEmail(this.email_id)
      },
    downloadFile(value) { 
      this.number++;
      let params = {};

      if (value === 'submit') {
        params.email_ids = this.email_id;
      } else {
        const ids = this.selected.map(item => item.id);
        params['ids[]'] = ids; // 👈 send array as query param
      }

      this.$httpSecured
        .get("/api/v1/warehouse/remarketing_buyers/download_buyer_info", {
          params
        })
        .then(response => {
          if (response.data) {
            if (value === 'submit') {
              this.snackbar = true;
              this.downloadDialog = false;
              this.email_id = '';
              this.snackbar = {
                color: "success",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: 'Success',
                text: response.data.message,
                visible: true
              };
            } else {
              const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              this.snackbar = {
                color: "success",
                icon: "mdi-check-circle",
                mode: "multi-line",
                position: "top",
                timeout: 3000,
                title: "Success",
                text: "(CSV File) Downloaded Successfully",
                visible: true
              };
            }
            this.selected = [];
            this.number = 0;
          } else {
            this.loading = false;
            this.showAlert("error", "No Data Found");
            this.number = 0;
          }
        })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network " + error);
          this.loading = false;
          this.number = 0;
        });
    },
    navigateToFileUpload() {
          this.$store.commit("setLotIds", {
          lotIds: this.headerText,
          inventoryId: "",
          action:'first_tab'
        });       
        this.$router.push({ name: "LotFileuploadComm" });
      },
    isActionDisabled(item) {
       if (item === 'Download') {
          return false;
        }
        if (item === 'Upload' || item === 'Add Buyer') {
          return ((item == 'Upload' || item == 'Add Buyer') && this.selected.length != 0);
        }
        return this.selected.length === 0;
    },
    updateAction(item) {
      if(item == 'Add Buyer'){
         this.navigateToAddBuyers('add');
      } else if(item == 'Upload'){
        this.navigateToFileUpload();
      }else if(item == 'Download'){
        if(this.selected.length > 0){          
          this.downloadFile('selected');
        }else{
          this.openPopup()
        }
      }else if(item == 'Delete'){
        this.deletRequest('delete');
      }else if(item == 'Block'){
        this.deletRequest('block');
      }else if(item == 'Unblock'){
        this.deletRequest('unblock');
      }else if(item == 'Edit'){
        this.navigateToAddBuyers('edit');
      }
    },
  }
}
</script>
<style scoped>
.item-selected {
  margin-top: 23px;
  position: absolute;
  left: 41%;
}

@media (max-height: 1104px) {
  .PaddingItemPerPage {
    padding: 8px !important;
  }
}

@media (min-height: 1126px) {
  .PaddingItemPerPage {
    padding: 24px !important;
  }
}

.v-dialog:has(.filter-dispatch) {
  justify-content: right;
  align-items: baseline;
  top: var(--dialog-ypos);
}

.v-dialog>.v-card>:has(.v-card__title) {
  overflow-wrap: break-word !important;
}

.custom-control_outlined .v-expansion-panel:before {
  box-shadow: none !important;
}

.custom-control_outlined button {
  min-height: 52px;
  border-width: 1px;
  border-color: rgba(0, 0, 0, .42);
  border-style: solid;
}

.custom-control_outlined button:focus {
  outline: none;
}

:deep(.v-dialog__content .filter-dispatch) {
  box-shadow: none !important;
}

.text-center {
  display: flow;
}
.v-data-table {
  height: calc(var(--vh, 1vh) * 100 - 268px) !important;
}
.filter_ui{
  margin-left: 12px !important;
  margin-top: 0px !important;
}
</style>